import React from 'react';
import { connect } from 'react-redux';
import {
  updateWaitingAreaGeneralInfo,
  resetWaitingAreaForm,
  selectWaitingAreaEntity,
} from '../../../../actions/waitingArea';
import { getWAByIdWithSearchTerm } from 'actions/organisation';
import { forceValidation } from '../../../../businessLogic/validation.js';
import { hideGlobalMessage } from '../../../../actions/globalMessage';
import { updateShowUpdateWaitingAreaModal } from '../../../../actions/modal';
import Info from '../../info';

class RightPanelUpdate extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      waitingAreaForm: props.waitingAreaForm,
      isWaitingAreaUpdating: false,
    };
  }
  updateWaitingArea = (e) => {
    let areThereErrors = forceValidation(undefined, undefined, 'updateWaitingAreaForm');
    if (!areThereErrors && !window.$(e.target).hasClass('disable') && !$('#wa-right-panel-save').hasClass('disable')) {
      let cb = (result, f) => {
        if (result) {
          let lastCb = (data) => {
            this.props.dispatch(selectWaitingAreaEntity(data));
            this.setState({ isWaitingAreaUpdating: false });
            this.resetForm();
          };
          this.props.dispatch(
            getWAByIdWithSearchTerm(this.props.waitingArea.id, this.props.waitingArea.orgNetworkId, lastCb)
          );
        } else {
          this.setState({ isWaitingAreaUpdating: false });
        }
      };
      this.setState({ isWaitingAreaUpdating: true });
      this.props.dispatch(updateWaitingAreaGeneralInfo(this.props.waitingAreaForm, cb));
    }
  };
  componentWillUnmount() {}

  cancelUpdateWaitingArea = () => {
    if (window.$('.global-message.color-bad-things-bg:visible').length > 0) this.props.dispatch(hideGlobalMessage());
    this.resetForm();
  };

  resetForm = () => {
    //TODO : reset dropdown used to be here, verify we still want that window.$('.meeting-room-create-update .ui.dropdown').dropdown('clear')
    this.props.dispatch(updateShowUpdateWaitingAreaModal(false));
    this.props.dispatch(resetWaitingAreaForm());
  };

  render() {
    let saveClasses =
      'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull ';
    if (!this.props.waitingAreaForm.shortDescription || this.props.waitingAreaForm.shortDescription == '') {
      //this can happen when the wa is created via self provision, description is empty so we apply the disable class
      saveClasses += ' disable ';
    }
    return (
      <div>
        <div className="ui actions mrbl max-width">
          <button
            id="wa-right-panel-save"
            tabIndex="4"
            type="button"
            onClick={this.updateWaitingArea}
            data-group="updatewaitingAreaForm"
            className={this.state.isWaitingAreaUpdating ? saveClasses + ' loading' : saveClasses}
          >
            {APP.LANGUAGE.Save}
            <i className="checkmark  icon" data-group="updatewaitingAreaForm" />
          </button>
          <button
            tabIndex="5"
            type="button"
            onClick={this.cancelUpdateWaitingArea}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
          >
            <i className="remove  icon" data-group="updatewaitingAreaForm" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>

        <Info paragraphs={[APP.LANGUAGE.WaitingAreaGeneralInfo.GeneralInfo]} paraClassName="mrtxxs" />
      </div>
    );
  }
}
let reduxGetterSetter = connect()(RightPanelUpdate); //CONNECT IS A REACT HELPER FUNCTION

export default reduxGetterSetter;
